import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDeskLamp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"desk-lamp, light, study"} maskId="square-filled-radius-0-stroke-1-IconDeskLamp"><path d="M15.5515 3C17.7554 3.0001 19.8956 4.30724 20.4997 6.51953C20.8476 7.79342 21.0488 9.10847 20.989 10.5215L20.9695 11H17.9997V17H16.9997V11H12.4997V20H16.9997V21H6.99974V20H11.4997V11H3.03099L3.01048 10.5215C2.95058 9.10842 3.15184 7.79345 3.49974 6.51953C4.10402 4.30721 6.24397 3 8.44798 3H15.5515Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconDeskLamp;
